import axios from 'axios'

const axiosUrl = axios.create({
    baseURL: process.env.NODE_ENV === 'production' ? process.env.REACT_APP_BACKEND_PATH_PROD : process.env.REACT_APP_BACKEND_PATH,
    
})

export default axiosUrl;